import { render, staticRenderFns } from "./PsychologistOpinion.vue?vue&type=template&id=1f17ee14&scoped=true&"
import script from "./PsychologistOpinion.vue?vue&type=script&lang=js&"
export * from "./PsychologistOpinion.vue?vue&type=script&lang=js&"
import style0 from "./PsychologistOpinion.vue?vue&type=style&index=0&id=1f17ee14&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f17ee14",
  null
  
)

export default component.exports